<template>
  <div class="page-header">
    <div class="container">
      <div class="row content">
        <div class="col-xs-12">
          <h1>
            Compare and switch in just four simple steps
          </h1>
          <p>
            Explore the market to find a cheaper, greener energy deal for you and your home
          </p>
          <slot></slot>
        </div>

        <div class="logo"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactUs from '../contact-us/ContactUs';
export default {
  name: 'PageHeader',
  components: { ContactUs }
};
</script>

<style lang="scss">
.page-header {
  background-color: #02017d;
  color: #fff;
  padding: 40px 0 30px 0;
  margin: 0;
  border: none;

  h1 {
    font-size: 40px;
    margin: 0;
    line-height: 1.2;
    color: #fff;
  }

  p {
    font-size: 20px;
    color: #fff;
  }

  .content {
    position: relative;
    padding-right: 390px;

    .logo {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translate(0, -50%);
      height: 256px;
      width: 359px;
      background: url('../../../assets/logo.png') no-repeat;
      background-size: contain;
      display: inline-block;
    }
  }

  @media (max-width: 767px) {
    h1 {
      font-size: 30px;
    }

    p {
      font-size: 15px;
    }

    .content {
      padding-right: 0;
      padding-top: 150px;

      .logo {
        position: absolute;
        right: auto;
        left: 15px;
        top: 20px;
        transform: translate(0, 0);
        height: 121px;
        width: 170px;
        max-width: calc(100% - 30px);
      }
    }
  }
}
</style>
